import { Component, Input, OnInit } from '@angular/core';
import { StopState } from 'src/app/_models/state/stopState';

@Component({
  selector: 'app-report-stop',
  templateUrl: './report-stop.component.html',
  styles: [],
})
export class ReportStopComponent implements OnInit {
  @Input() stop: string;
  @Input() routeColor: string;
  @Input() stopText: StopState;

  stopType: string;
  stopNumber = '';

  ngOnInit() {
    // TODO clean up and handle missing/bad data
    this.stopType = this.stop.substring(0, 1);
    const idx = this.stop.indexOf(':');
    if (this.stopType === 'S') {
      this.stopNumber = this.stop.substring(0, idx).split(' ')[1];
    }
  }
}
